import { render, staticRenderFns } from "./UsuarioPermisosTree.vue?vue&type=template&id=cb1e8b36&scoped=true"
import script from "./UsuarioPermisosTree.vue?vue&type=script&lang=js"
export * from "./UsuarioPermisosTree.vue?vue&type=script&lang=js"
import style0 from "./UsuarioPermisosTree.vue?vue&type=style&index=0&id=cb1e8b36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb1e8b36",
  null
  
)

export default component.exports